import { axiosService } from "./axiosService";

const certificateApi = {
    getAll(params) {
        const url = `/certificate`;
        return axiosService.get(url, { params })
    },
    create(body) {
        const url = '/certificate';
        return axiosService.post(url, body)
    },
    update(id, body) {
        const url = `/certificate/${id}`;
        return axiosService.put(url, body)
    },
    delete(id) {
        const url = `/certificate/${id}`;
        return axiosService.delete(url)
    },
}

export default certificateApi;